import React, { Fragment } from "react";
import { PropTypes } from "prop-types";
import HtmlTooltip from "./HtmlTooltip";

export default function ItemUnitOfMeasure({ type }) {
  return (
    <HtmlTooltip
      type={type}
      title={
        <Fragment>
          <p>
            <b>Unit of measure info for inventory items</b>
          </p>
          <p>
            This object is structured as follows:
            <pre>
              <code>
                {`
{
  "uom": {
    "id": integer,
    "name": string
  },
  "conversion": decimal,
  "isBase": boolean,
  "salesPrice": decimal,
  "purchaseCost": decimal
}`}
              </code>
            </pre>
          </p>
          <p>
            Note that only one of the item's unit of measure entries can be the
            base ("isBase"). The others convert from the "isBase" entry, using
            their "conversion" value.
          </p>
        </Fragment>
      }
    ></HtmlTooltip>
  );
}
ItemUnitOfMeasure.propTypes = {
  type: PropTypes.string.isRequired
};
